import axiosV1 from "@/plugins/axios/configV1";

const tradeInBaseURL = "product-registrations/trade-in-rewards";

export default {
    /** Fetch dropdown options for the Add/Edit form */
    getCustomers(params) {
        return axiosV1.get(`${tradeInBaseURL}/customers`, { params });
    },
    getStores(params) {
        return axiosV1.get(`${tradeInBaseURL}/stores`, { params });
    },
    getCategories() {
        return axiosV1.get(`${tradeInBaseURL}/categories/list`);
    },
    addCategory(payload = {}) {
        return axiosV1.post(`${tradeInBaseURL}/categories`, payload);
    },
    deleteCategory(id = null) {
        return axiosV1.post(`${tradeInBaseURL}/categories/delete/${id}`);
    },
    deleteCategoryAffected(id = null) {
        return axiosV1.get(`${tradeInBaseURL}/categories/delete-affected/${id}`);
    },
    getStatuses() {
        return axiosV1.get(`${tradeInBaseURL}/statuses`);
    },
    getTradeInPromos() {
        return axiosV1.get(`${tradeInBaseURL}/promos`);
    },

    /** Fetch Trade-In Rewards list (includes search/filter/sort/pagination) */
    getTradeInRewards(params = {}) {
        const { category, ...rest } = params;
        return axiosV1.get(tradeInBaseURL, { params: { ...rest, categories: category } });
    },

    /** Fetch a single Trade-In Reward by ID */
    getTradeInReward(id) {
        return axiosV1.get(`${tradeInBaseURL}/${id}`);
    },

    /** Create a Trade-In Reward */
    addTradeInReward(payload = {}) {
        return axiosV1.post(tradeInBaseURL, payload);
    },

    /** Update a Trade-In Reward */
    updateTradeInReward(id, payload = {}) {
        return axiosV1.put(`${tradeInBaseURL}/${id}`, payload);
    },

    /** Approve a Trade-In Reward (moves it to Floating and sets its points) */
    approveTradeInReward(id, payload = {}) {
        return axiosV1.post(`${tradeInBaseURL}/${id}/approve`, payload);
    },

    /** Approve multiple Trade-In Rewards at once */
    approveTradeInRewards(ids = []) {
        return axiosV1.post(`${tradeInBaseURL}/approve-all`, { ids });
    },

    /** Reject a Trade-In Reward */
    rejectTradeInReward(id, payload = {}) {
        return axiosV1.post(`${tradeInBaseURL}/${id}/reject`, payload);
    },
};
